import React from 'react';
import _ from 'lodash';
import { Icon, Alert } from 'antd';
import {  FormattedMessage } from 'react-intl';
import styles from './SpamAlertText.module.scss';
import InfoIconWithTooltip from '../InfoIconWithTooltip/InfoIconWithTooltip';
import messages from '../../../Containers/ManualSearchV2/ManualSearchMessages';


const SpamAlertText = props => {
  const { style, junkWords = [], setIsJunkWordFound, alertStyle } = props;

  const onClickClose = () => {
    if (setIsJunkWordFound) setIsJunkWordFound(false);
  };
  const tooltipTitle = (
    <div>
      <FormattedMessage {...messages.belowAreTheSpamWordsLabel} />
      <div>{_.uniq(junkWords).join(', ')}</div>
    </div>
  );
  return (
    <div style={style}>
      <Alert
        message={
          <div className={styles.messageWithTooltip}>
            <div><FormattedMessage {...messages.spamWordsDetectedLabel} /></div>
            <InfoIconWithTooltip
              tooltipTitle={tooltipTitle}
              style={{ zIndex: 11111, maxHeight: '250px', overflowY: 'auto' }}
              className={styles.spamTooltip}
              placement="right"
            />
          </div>
        }
        type="error"
        showIcon
        icon={<Icon type="close-circle" theme="filled" />}
        closable
        className={styles.spamAlertText}
        onClose={onClickClose}
        style={alertStyle}
      />
    </div>
  );
};

export default SpamAlertText;
